module.exports = __webpack_public_path__ + "static/images/bg-popup-title.a207ba4.jpg";